<template>
  <div>
    <nav-breadcrumb :menu="[{label: productId ? '编辑产品' : '新增产品'}]"/>
    <el-row>
      <el-col>
        <el-form :model="productForm" :rules="productFormRules" ref="productForm" label-width="150px">
          <el-row :gutter="10" class="bg-purple xamhtrpg">
            <el-col :span="12">
              <el-form-item label="产品名称：" prop="p__productName">
                <el-input v-model="productForm.p__productName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品编号：" prop="p__productCode">
                <el-input v-model="productForm.p__productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="额度：" prop="p__creditCap">
                <el-input type="number" v-model="productForm.p__creditCap">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="期限：" prop="p__repaymentCount">
                <el-input type="number" v-model="productForm.p__repaymentCount">
                  <template slot="append">月</template>
                </el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="12">-->
<!--              <el-form-item label="服务费：" prop="p__lendingFee">-->
<!--                <el-col :span="12">-->
<!--                  <el-select v-model="productForm.p__lendingFeeType">-->
<!--                    <el-option v-for="(item,idx) in lendingFeeTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                  <el-input v-model="productForm.p__lendingFee">-->
<!--                    <template slot="append">{{productForm.p__lendingFeeType == 'Rate' ? '%' : '元'}}</template>-->
<!--                  </el-input>-->
<!--                </el-col>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="执行利率(%)：" prop="p__interestRate">-->
<!--                <el-col :span="12">-->
<!--                  <el-select v-model="productForm.p__interestType">-->
<!--                    <el-option v-for="(item,idx) in interestTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                  <el-input v-model="productForm.p__interestRate">-->
<!--                    <template slot="append">%</template>-->
<!--                  </el-input>-->
<!--                </el-col>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24">
              <el-form-item label="产品条款协议：" prop="i__tc">
                <el-input type="textarea" v-model="productForm.i__tc"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="tr">
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import interestTypeOptions from "../../../utils/interestTypeOptions"
  import lendingFeeTypeOptions from '../../../utils/lendingFeeTypeOptions'

  export default {
    name: "ServerAdminProductEdit",
    data() {
      return {
        productId: this.$route.query['p.productId'],
        productForm: {
          p__productId: '',
          p__productName: '',
          p__productCode: '',
          p__creditCap: '',
          // p__validityPeriod: '',
          // p__lendingFee: '',
          // p__lendingType: '',
          // p__interestRate: '',
          p__productStatus: "Active",
          p__repaymentCount: 36,
          i__tc: ""

        },
        productFormRules: {
          p__productName: [
            {
              required: true,
              message: '产品名称不能为空！'
            }
          ],
          p__productCode: [
            {
              required: true,
              message: '产品编号不能为空！'
            }
          ],
          p__creditCap: [
            {
              required: true,
              message: '产品额度不能为空！'
            }
          ],
          p__repaymentCount: [
            {
              required: true,
              message: '产品期限不能为空！'
            }
          ],
          // p__lendingFee: [
          //   {
          //     required: true,
          //     message: '服务费不能为空！'
          //   }
          // ],
          // p__interestRate: [
          //   {
          //     required: true,
          //     message: '执行利率不能为空！'
          //   }
          // ],
          i__tc: [
            {
              required: true,
              message: '产品条款协议不能为空！'
            }
          ],
        },
        interestTypeOptions,
        lendingFeeTypeOptions
      }
    },
    mounted() {
      if( this.productId) {
        this.getFinanceProductDetail( this.productId )
      }
    },
    methods: {
      getFinanceProductDetail: function(productId) {
        xhr.getFinanceProductDetail({
            'p.productId': productId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.productForm = res.data.data
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function () {
        this.$refs.productForm.validate(valid=> {
          if(valid) {
            xhr.updateFinanceProduct(this.productForm, res=> {
              try{
                if(res.data.status == 'success') {
                  this.$router.back()
                }
              }catch (e) {

              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ProductEdit.vue